import { stateMark, type StepState } from "./route";

const look: Record<StepState, string> = {
  done: "bg-oksoft border-accdim text-ok",
  active: "bg-accsoft border-acc text-acc",
  open: "bg-card border-bd2 text-ink2",
  locked: "bg-transparent border-dashed border-bd text-mut",
};

/** Марка состояния шага: ✓ ▸ ○ · (S2). */
export function StepMark({ state, size = 20 }: { state: StepState; size?: number }) {
  const { mark, label } = stateMark(state);
  return (
    <span
      aria-label={label}
      title={label}
      className={`inline-grid flex-none place-items-center rounded-sm border font-mono text-[11px] ${look[state]}`}
      style={{ width: size, height: size }}
    >
      {mark}
    </span>
  );
}
